const ClientSimpleTrendChart = ({ trends = [], title }) => {
  if (!trends.length) {
    return <p className="muted">No opportunities were generated during this date range.</p>;
  }

  const max = Math.max(
    ...trends.map((t) => Math.max(t.newCount || 0, t.contactedCount || 0, t.closedWonCount || 0)),
    1
  );
  const width = 480;
  const height = 160;
  const padding = 24;
  const innerW = width - padding * 2;
  const innerH = height - padding * 2;
  const step = trends.length > 1 ? innerW / (trends.length - 1) : 0;

  const linePoints = (key) =>
    trends
      .map((t, i) => {
        const x = padding + i * step;
        const y = padding + innerH - ((t[key] || 0) / max) * innerH;
        return `${x},${y}`;
      })
      .join(" ");

  const formatLabel = (date) => {
    try {
      return new Date(date).toLocaleDateString(undefined, { month: "short", day: "numeric" });
    } catch {
      return "";
    }
  };

  return (
    <div className="client-simple-chart" role="img" aria-label={title || "Trend chart"}>
      {title ? <h4>{title}</h4> : null}
      <svg viewBox={`0 0 ${width} ${height}`} className="client-simple-chart__svg">
        <polyline points={linePoints("newCount")} fill="none" stroke="var(--accent, #2563eb)" strokeWidth="2" />
        <polyline points={linePoints("contactedCount")} fill="none" stroke="var(--warning, #d97706)" strokeWidth="2" />
        <polyline points={linePoints("closedWonCount")} fill="none" stroke="var(--success, #059669)" strokeWidth="2" />
      </svg>
      <div className="client-simple-chart__legend">
        <span><i className="swatch swatch--new" /> New</span>
        <span><i className="swatch swatch--contacted" /> Contacted</span>
        <span><i className="swatch swatch--won" /> Closed / Won</span>
      </div>
      <div className="client-simple-chart__axis-labels">
        {trends.map((t) => (
          <span key={String(t.date)}>{formatLabel(t.date)}</span>
        ))}
      </div>
    </div>
  );
};

export default ClientSimpleTrendChart;
